//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaColumns', {
//        templateUrl: 'views/components/views/metaColumns/metaColumns.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'metaColumnsService', function ($stateParams, stateService, metaColumnsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let metaTableKeyno = $stateParams.metatable_keyno;

//            vm.model = {
//                itemsListMetaColumns: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadMetaColumns() {
//                vm.model.itemsListMetaColumns = await metaColumnsService.listMetaColumns({ metatable_keyno: metaTableKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'metacolumn':
//                        go({
//                            metatable_keyno: metaTableKeyno,
//                            metacolumn_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMetaColumns();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
